import Api from "@/components/customAxios/Axios";

const IsTokenValid = async () => {
	try {
		const response = await Api.get("/validate-token");
		if (response.status === 200) {
			return true;
		}
		return false;
	} catch (error) {
		return false;
	}
};

export default IsTokenValid;
